import { render, staticRenderFns } from "./holiday-dialog.vue?vue&type=template&id=28ef2d1c&"
import script from "./holiday-dialog.vue?vue&type=script&lang=js&"
export * from "./holiday-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports